import type { CartItem } from './types'

const STORAGE_KEY = 'cart-list'

export function addToCart(item: CartItem): number {
  const currentList = getCartItems()
  const existingItemIndex = currentList.findIndex(
    (i) =>
      i.id === item.id &&
      i.type === item.type &&
      JSON.stringify(i.parameters) === JSON.stringify(item.parameters)
  )

  if (existingItemIndex !== -1) {
    currentList[existingItemIndex].quantity += item.quantity
  } else {
    currentList.push(item)
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(currentList))
  return currentList.length
}

export function removeFromCart(item: CartItem) {
  const currentList = getCartItems()
  // id уникален для каждой позиции (ставится Date.now() при добавлении),
  // поэтому сопоставление только по id + type: parameters позиции могли
  // уже измениться (дизайн), и по полному совпадению мы её не найдём.
  const updatedList = currentList.filter(
    (i) => !(i.id === item.id && i.type === item.type)
  )

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList))
}

export function updateCartItem(item: CartItem) {
  const currentList = getCartItems()
  const existingItemIndex = currentList.findIndex(
    (i) => i.id === item.id && i.type === item.type
  )

  if (existingItemIndex !== -1) {
    currentList[existingItemIndex] = item
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentList))
  }
}

export function getCartItems(): CartItem[] {
  const stored = localStorage.getItem(STORAGE_KEY)
  const items: CartItem[] = stored ? JSON.parse(stored) : []

  // Позиции со quantity > 1 остались от старой версии корзины: раскладываем
  // на отдельные строки, чтобы каждую можно было удалить индивидуально.
  // id генерируются против уже занятых: у двух исходных позиций «Date.now() +
  // индекс» мог совпасть, и удаление одной строки сносило бы чужую.
  if (!items.some((item) => item.quantity > 1)) return items

  const taken = new Set(items.map((item) => item.id))
  const nextId = () => {
    let id = Date.now()
    while (taken.has(id)) id += 1
    taken.add(id)
    return id
  }
  const flattened = items.flatMap((item) =>
    Array.from({ length: item.quantity }, (_, index) => ({
      ...item,
      id: index === 0 ? item.id : nextId(),
      quantity: 1
    }))
  )
  localStorage.setItem(STORAGE_KEY, JSON.stringify(flattened))
  return flattened
}

export function clearCart() {
  localStorage.removeItem(STORAGE_KEY)
}
